module.exports = __webpack_public_path__ + "img/jinbi.png";